import employees from 'modules/employees/store/collections/employees'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'

import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'

export const calendarEventCanReadLeaves = (calendarEvent: CalendarEvent) => {
  const employee = employees.get(calendarEvent.attributes.metadata.employee_id)

  if (!employee) return false

  return employee.policy.can('readLeaves')
}

export const calendarEventCanSeeTimeoffTypes = (calendarEvent: CalendarEvent) => {
  const identifier = calendarEvent.attributes.metadata.leave_type

  if (!identifier) return false // Not all CalendarEvents are leaves!

  const leaveTypeId = calendarEvent.attributes.metadata.leave_type_id

  const leaveType = leaveTypes.find({
    id: leaveTypeId,
  })

  if (!leaveType) return false

  return leaveType.attributes.visibility || calendarEventCanReadLeaves(calendarEvent)
}
